import { Gift } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { usePersonnalisation } from '../hooks/usePersonnalisation';
import { dateFr } from '../utils/dates';

/**
 * Le décompte de la période offerte par la plateforme.
 *
 * Il vit sous le logo, en badge d'avertissement : le ruban en travers du coin
 * mangeait l'écran pour une information qui se lit d'un regard. Il regarde les
 * membres, pas les visiteurs — un passant n'a pas à savoir ce que la
 * plateforme offre à l'association — et tombe de lui-même à l'échéance.
 */
export default function BadgeGratuite({ className = '' }: { className?: string }) {
  const perso = usePersonnalisation();
  const { user } = useAuth();

  /*
    SUR UNE DEMONSTRATION, CE BADGE S'EFFACE.

    Il annonce la fin d'un cadeau ; le badge de remise a zero annonce
    l'effacement de ce qu'on vient de saisir. Les deux disent une echeance, au
    meme endroit, dans la meme forme : cote a cote, on lit le premier et l'on
    croit avoir lu les deux.

    Sur une demonstration, c'est le second qui compte — et la periode offerte
    n'y a de toute facon aucun sens, puisque personne ne paie une
    demonstration.
  */
  if ((perso as { demonstration?: unknown } | null)?.demonstration != null) return null;

  if (!user || !perso?.gratuiteFin) return null;

  const fin = new Date(perso.gratuiteFin + 'T23:59:59');
  const jours = Math.ceil((fin.getTime() - Date.now()) / 86_400_000);
  if (jours < 0) return null;

  const finLisible = dateFr(fin);

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200 px-2.5 py-0.5 text-[0.7rem] font-semibold whitespace-nowrap ${className}`}
      title={`Période offerte par la plateforme jusqu'au ${finLisible}`}
    >
      <Gift className="w-3 h-3 shrink-0" aria-hidden="true" />
      {jours === 0 ? 'Offert — dernier jour' : `Offert — J-${jours}`}
    </span>
  );
}
